import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetCompetitors_competitors_edges_node as Competitor,
    GetCompetitors as GetCompetitorsQuery,
} from 'nutshell-graphql-types';

import GET_COMPETITORS from '../queries/get-competitors.graphql';

export const useGetCompetitors = (): {
    isLoading: boolean;
    errorMessage: string | null | undefined;
    competitors: Competitor[];
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<GetCompetitorsQuery, Record<any, any>>(
        GET_COMPETITORS,
        {
            notifyOnNetworkStatusChange: true,
        }
    );

    return {
        isLoading: loading,
        refetch,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
        competitors:
            data && data.competitors && data.competitors.edges
                ? data.competitors.edges.map((edge) => edge.node)
                : [],
    };
};
